// 엔카 이용약관
export const policyInfo = {
	terms: {
		componentName: 'Terms',
		deploy: [
			{
				ver: 13,
				date: '2026/06/30',
			},
			{
				ver: 12,
				date: '2025/11/04',
			},
			{
				ver: 11,
				date: '2024/07/25',
			},
			{
				ver: 10,
				date: '2021/10/01',
			},
			{
				ver: 9,
				date: '2020/05/21',
			},
			{
				ver: 8,
				date: '2014/12/29',
			},
			{
				ver: 7,
				date: '2014/04/02',
			},
			{
				ver: 6,
				date: '2014/01/04',
			},
			{
				ver: 5,
				date: '2013/07/22',
			},
			{
				ver: 4,
				date: '2013/06/07',
			},
			{
				ver: 3,
				date: '2012/06/16',
			},
			{
				ver: 2,
				date: '2010/11/13',
			},
			{
				ver: 1,
				date: '2009/03/25',
			},
		],
	},
	location: {
		componentName: 'Location',
		deploy: [
			{
				ver: 3,
				// date: '2020/05/21',
				versionNumber: '1.2',
			},
			{
				ver: 2,
				// date: '2018/10/29',
				versionNumber: '1.1',
			},
			{
				ver: 1,
				// date: '2018/04/01',
				versionNumber: '1.0',
			},
		],
	},
	privacy: {
		componentName: 'Privacy',
		deploy: [
			{
				ver: 104,
				versionNumber: '13.5',
			},
			{
				ver: 103,
				versionNumber: '13.4',
			},
			{
				ver: 102,
				versionNumber: '13.3',
			},
			{
				ver: 101,
				versionNumber: '13.2',
			},
			{
				ver: 100,
				versionNumber: '13.1',
			},
			{
				ver: 99,
				versionNumber: '13.0',
			},
			{
				ver: 98,
				versionNumber: '12.9',
			},
			{
				ver: 97,
				versionNumber: '12.8',
			},
			{
				ver: 96,
				versionNumber: '12.7',
			},
			{
				ver: 95,
				versionNumber: '12.6',
			},
			{
				ver: 94,
				versionNumber: '12.5',
			},
			{
				ver: 93,
				versionNumber: '12.4',
			},
			{
				ver: 92,
				versionNumber: '12.3',
			},
			{
				ver: 91,
				versionNumber: '12.2',
			},
			{
				ver: 90,
				versionNumber: '12.1',
			},
			{
				ver: 89,
				versionNumber: '12.0',
			},
			{
				ver: 88,
				versionNumber: '11.9',
			},
			{
				ver: 87,
				versionNumber: '11.8',
			},
			{
				ver: 86,
				versionNumber: '11.7',
			},
			{
				ver: 85,
				versionNumber: '11.6',
			},
			{
				ver: 84,
				versionNumber: '11.5',
			},
			{
				ver: 83,
				versionNumber: '11.4',
			},
			{
				ver: 82,
				// date: '2025/11/04',
				versionNumber: '11.3',
			},
			{
				ver: 81,
				// date: '2025/09/23',
				versionNumber: '11.2',
			},
			{
				ver: 80,
				// date: '2025/09/2',
				versionNumber: '11.1',
			},
			{
				ver: 79,
				// date: '2025/08/28',
				versionNumber: '11.0',
			},
			{
				ver: 78,
				// date: '2025/08/07',
				versionNumber: '10.9',
			},
			{
				ver: 77,
				// date: '2025/7/22',
				versionNumber: '10.8',
			},
			{
				ver: 76,
				// date: '2025/7/17',
				versionNumber: '10.7',
			},
			{
				ver: 75,
				// date: '2025/6/26',
				versionNumber: '10.6',
			},
			{
				ver: 74,
				// date: '2025/6/2',
				versionNumber: '10.5',
			},
			{
				ver: 73,
				// date: '2025/5/29',
				versionNumber: '10.4',
			},
			{
				ver: 72,
				// date: '2025/5/20',
				versionNumber: '10.3',
			},
			{
				ver: 71,
				// date: '2025/5/15',
				versionNumber: '10.2',
			},
			{
				ver: 70,
				// date: '2025/4/24',
				versionNumber: '10.1',
			},
			{
				ver: 69,
				// date: '2025/4/10',
				versionNumber: '10.0',
			},
			{
				ver: 68,
				// date: '2025/xx',
				versionNumber: '9.9',
			},
			{
				ver: 67,
				// date: '2025/3/13',
				versionNumber: '9.8',
			},
			{
				ver: 66,
				// date: '2025/2/25',
				versionNumber: '9.7',
			},
			{
				ver: 65,
				// date: '2025/xx/xx',
				versionNumber: '9.6',
			},
			{
				ver: 64,
				// date: '2025/01/09',
				versionNumber: '9.5',
			},
			{
				ver: 63,
				// date: '2024/12/5',
				versionNumber: '9.4',
			},
			{
				ver: 62,
				// date: '2024/11/28',
				versionNumber: '9.3',
			},
			{
				ver: 61,
				// date: '2024/10/XX',
				versionNumber: '9.2',
			},
			{
				ver: 60,
				// date: '2024/09/23',
				versionNumber: '9.1',
			},
			{
				ver: 59,
				// date: '2024/09/05',
				versionNumber: '9.0',
			},
			{
				ver: 58,
				// date: '2024/08/22',
				versionNumber: '8.9',
			},
			{
				ver: 57,
				// date: '2024/07/24',
				versionNumber: '8.8',
			},
			{
				ver: 56,
				// date: '2024/05/28',
				versionNumber: '8.7',
			},
			{
				ver: 55,
				// date: '2024/04/16',
				versionNumber: '8.6',
			},
			{
				ver: 54,
				// date: '2024/04/16',
				versionNumber: '8.5',
			},
			{
				ver: 53,
				// date: '2023/12/19',
				versionNumber: '8.4',
			},
			{
				ver: 52,
				// date: '2023/10/17',
				versionNumber: '8.3',
			},
			{
				ver: 51,
				// date: '2023/09/14',
				versionNumber: '8.2',
			},
			{
				ver: 50,
				// date: '2023/08/17',
				versionNumber: '8.1',
			},
			{
				ver: 49,
				// date: '2023/08/08',
				versionNumber: '8.0',
			},
			{
				ver: 48,
				// date: '2023/08/01',
				versionNumber: '7.9',
			},
			{
				ver: 47,
				// date: '2023/06/20',
				versionNumber: '7.8',
			},
			{
				ver: 46,
				// date: '2023/05/30',
				versionNumber: '7.7',
			},
			{
				ver: 45,
				// date: '2023/03/03',
				versionNumber: '7.6',
			},
			{
				ver: 44,
				// date: '2023/03/03',
				versionNumber: '7.5',
			},
			{
				ver: 43,
				// date: '2022/12/15',
				versionNumber: '7.4',
			},
			{
				ver: 42,
				// date: '2022/08/30',
				versionNumber: '7.3',
			},
			{
				ver: 41,
				// date: '2022/05/31',
				versionNumber: '7.2',
			},
			{
				ver: 40,
				// date: '2021/12/14',
				versionNumber: '7.1',
			},
			{
				ver: 39,
				// date: '2021/08/31',
				versionNumber: '7.0',
			},
			{
				ver: 38,
				// date: '2021/03/23',
				versionNumber: '6.9',
			},
			{
				ver: 37,
				// date: '2020/12/01',
				versionNumber: '6.8',
			},
			{
				ver: 36,
				// date: '2020/08/27',
				versionNumber: '6.7',
			},
			{
				ver: 35,
				// date: '2020/05/21',
				versionNumber: '6.6',
			},
			{
				ver: 34,
				// date: '2019/12/17',
				versionNumber: '6.5',
			},
			{
				ver: 33,
				// date: '2019/10/29',
				versionNumber: '6.4',
			},
			{
				ver: 32,
				// date: '2019/08/01',
				versionNumber: '6.3',
			},
			{
				ver: 31,
				// date: '2019/07/16',
				versionNumber: '6.2',
			},
			{
				ver: 30,
				// date: '2019/04/30',
				versionNumber: '6.1',
			},
			{
				ver: 29,
				// date: '2019/03/12',
				versionNumber: '6.0',
			},
			{
				ver: 28,
				// date: '2018/10/29',
				versionNumber: '5.9',
			},
			{
				ver: 27,
				// date: '2018/07/30',
				versionNumber: '5.8',
			},
			{
				ver: 26,
				// date: '2018/04/16',
				versionNumber: '5.7',
			},
			{
				ver: 25,
				// date: '2018/02/24',
				versionNumber: '5.6',
			},
			{
				ver: 24,
				// date: '2018/01/15',
				versionNumber: '5.5',
			},
			{
				ver: 23,
				// date: '2017/08/23',
				versionNumber: '5.4',
			},
			{
				ver: 22,
				// date: '2017/07/31',
				versionNumber: '5.3',
			},
			{
				ver: 21,
				// date: '2017/06/05',
				versionNumber: '5.2',
			},
			{
				ver: 20,
				// date: '2016/10/24',
				versionNumber: '5.1',
			},
			{
				ver: 19,
				// date: '2016/08/01',
				versionNumber: '5.0',
			},
			{
				ver: 18,
				// date: '2016/05/28',
				versionNumber: '4.9',
			},
			{
				ver: 17,
				// date: '2016/04/11',
				versionNumber: '4.8',
			},
			{
				ver: 16,
				// date: '2015/11/02',
				versionNumber: '4.7',
			},
			{
				ver: 15,
				// date: '2015/09/24',
				versionNumber: '4.6',
			},
			{
				ver: 14,
				// date: '2015/06/15',
				versionNumber: '4.5',
			},
			{
				ver: 13,
				// date: '2015/04/07',
				versionNumber: '4.4',
			},
			{
				ver: 12,
				// date: '2014/12/22',
				versionNumber: '4.3',
			},
			{
				ver: 11,
				// date: '2014/12/08',
				versionNumber: '4.2',
			},
			{
				ver: 10,
				// date: '2014/06/23',
				versionNumber: '4.1',
			},
			{
				ver: 9,
				// date: '2014/04/02',
				versionNumber: '4.0',
			},
			{
				ver: 8,
				// date: '2014/02/24',
				versionNumber: '3.2',
			},
			{
				ver: 7,
				// date: '2013/10/14',
				versionNumber: '3.1',
			},
			{
				ver: 6,
				// date: '2013/05/31',
				versionNumber: '3.0',
			},
			{
				ver: 5,
				// date: '2012/11/19',
				versionNumber: '2.1',
			},
			{
				ver: 4,
				// date: '2012/08/20',
				versionNumber: '2.0',
			},
			{
				ver: 3,
				// date: '2012/06/16',
				versionNumber: '1.3',
			},
			{
				ver: 2,
				// date: '2012/06/11',
				versionNumber: '1.2',
			},
			{
				ver: 1,
				// date: '2007/11/24',
				versionNumber: '1.1',
			},
		],
	},
	cctv: {
		componentName: 'Cctv',
		deploy: [
			{
				ver: 13,
				versionNumber: '2.2',
			},
			{
				ver: 12,
				versionNumber: '2.1',
			},
			{
				ver: 11,
				// date: '2025/08/28',
				versionNumber: '2.0',
			},
			{
				ver: 10,
				// date: '2024/08/22',
				versionNumber: '1.9',
			},
			{
				ver: 9,
				// date: '2023/09/14',
				versionNumber: '1.8',
			},
			{
				ver: 8,
				// date: '2023/08/01',
				versionNumber: '1.7',
			},
			{
				ver: 7,
				// date: '2021/12/14',
				versionNumber: '1.6',
			},
			{
				ver: 6,
				// date: '2020/05/21',
				versionNumber: '1.5',
			},
			{
				ver: 5,
				// date: '2018/10/29',
				versionNumber: '1.4',
			},
			{
				ver: 4,
				// date: '2014/12/08',
				versionNumber: '1.3',
			},
			{
				ver: 3,
				// date: '2014/07/16',
				versionNumber: '1.2',
			},
			{
				ver: 2,
				// date: '2014/06/23',
				versionNumber: '1.1',
			},
			{
				ver: 1,
				// date: '2014/04/02',
				versionNumber: '1.0',
			},
		],
	},
	youth: {
		componentName: 'Youth',
		deploy: [
			{
				ver: 1,
				versionNumber: '1.0',
			},
		],
	},
};

export default null;
